<script setup lang="ts">
import ArrowLeftIcon from '@/assets/double-arrow-left.svg'
import ArrowRightIcon from '@/assets/double-arrow-right.svg'
import { ref } from 'vue'

const scrollRef = ref<HTMLDivElement | null>(null)
const isStart = ref(true)
const isEnd = ref(false)

const onScroll = (e: Event) => {
  const element = e.target as HTMLDivElement | null
  if (!element) {
    console.warn('No element found')
    return
  }
  isEnd.value = Math.abs(element.scrollWidth - element.clientWidth - element.scrollLeft) <= 0
  isStart.value = element.scrollLeft === 0
}

const onArrowLeftClick = () => {
  if (!scrollRef.value) {
    console.warn('No element found')
    return
  }
  scrollRef.value.scrollTo({
    left: scrollRef.value.scrollLeft - scrollRef.value.clientWidth / 3,
    behavior: 'smooth'
  })
}

const onArrowRightClick = () => {
  if (!scrollRef.value) {
    console.warn('No element found')
    return
  }
  scrollRef.value.scrollTo({
    left: scrollRef.value.scrollLeft + scrollRef.value.clientWidth / 3,
    behavior: 'smooth'
  })
}
</script>

<template>
  <div>
    <div class="relative">
      <transition>
        <div
          v-if="!isStart"
          class="absolute top-0 bottom-0 left-0 z-50 flex cursor-pointer items-center rounded bg-linear-to-r from-white/10 to-transparent"
          @click="onArrowLeftClick"
        >
          <ArrowLeftIcon />
        </div>
      </transition>
      <transition>
        <div
          v-if="!isEnd"
          class="absolute top-0 right-0 bottom-0 z-50 flex cursor-pointer items-center bg-linear-to-r from-transparent to-white/10"
          @click="onArrowRightClick"
        >
          <ArrowRightIcon />
        </div>
      </transition>
      <div ref="scrollRef" class="no-scrollbar overflow-x-auto" @scroll="onScroll">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.15s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
